/**
 * Module-level counter of in-flight API requests.
 * Kept outside React so both apiFetch and mockDelay can update it without
 * needing access to a context or hook.
 */

let count = 0;
const listeners = new Set<() => void>();

function notify() {
    listeners.forEach((fn) => {
        fn();
    });
}

export function incrementRequests(): void {
    count++;
    notify();
}
export function decrementRequests(): void {
    count = Math.max(0, count - 1);
    notify();
}
export function getRequestCount(): number {
    return count;
}

/** Returns an unsubscribe function. */
export function subscribeToRequests(fn: () => void): () => void {
    listeners.add(fn);
    return () => {
        listeners.delete(fn);
    };
}
